export function getCartKey() {
  return localStorage.getItem('cart_key');
}
